import { extractEmailDomain } from "./generic-email-domains";

export const GUEST_EMAIL_DOMAIN = "guests.repackify.com";

export function isGuestPlaceholderEmail(email: string): boolean {
  return extractEmailDomain(email) === GUEST_EMAIL_DOMAIN;
}
